import React from 'react';
import styles from './Spinner.module.css';

interface LoadingModalProps {
  isVisible: boolean;
  message: string;
  type?: 'loading' | 'success' | 'error';
}

export interface ModalState {
  isVisible: boolean;
  message: string;
  type: 'loading' | 'success' | 'error';
}

export const LoadingModal: React.FC<LoadingModalProps> = ({ isVisible, message, type = 'loading' }) => {
  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'loading':
        return (
          <div className={styles.spinner}>
            <div className={styles.spinnerRing}></div>
          </div>
        );
      case 'success':
        return (
          <div className={styles.successIcon}>
            <div className={styles.successCheck}></div>
          </div>
        );
      case 'error':
        return (
          <div className={styles.errorIcon}>
            <div className={styles.errorX}></div>
          </div>
        );
      default:
        return (
          <div className={styles.spinner}>
            <div className={styles.spinnerRing}></div>
          </div>
        );
    }
  };

  const getMessageClass = () => {
    switch (type) {
      case 'success':
        return styles.messageSuccess;
      case 'error':
        return styles.messageError;
      default:
        return styles.messageLoading;
    }
  };

  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.modalBox}>
        {getIcon()}
        <p className={`${styles.message} ${getMessageClass()}`}>{message}</p>
      </div>
    </div>
  );
};
